import {
    AnalyticsDashboard,
    Comments,
    KpiMonitor,
    LiveMonitor,
    PipelineMonitor,
    PredictionManagement,
} from '~/config/components';

export const customRoutes = [
    {
        path: '/comments',
        component: Comments,
        meta: {
            onlyIfAuthenticated: true,
            sidebarWidthGroup: 'comments',
        }
    },
    {
        path: '/pipeline-monitor',
        component: PipelineMonitor,
        meta: {
            onlyIfAuthenticated: true,
            sidebarWidthGroup: 'pipeline-monitor',
        },
    },
    {
        path: '/live-monitor',
        component: LiveMonitor,
        meta: {
            onlyIfAuthenticated: true,
            sidebarWidthGroup: 'live-monitor',
        },
    },
    {
        path: '/prediction-management',
        component: PredictionManagement,
        meta: {
            onlyIfAuthenticated: true,
            sidebarWidthGroup: 'prediction-management',
        },
    },
    {
        path: '/analytics',
        component: AnalyticsDashboard,
        meta: {
            onlyIfAuthenticated: true,
            sidebarWidthGroup: 'analytics',
        },
    },
    {
        path: '/wc-kpis',
        component: KpiMonitor,
        meta: {
            onlyIfAuthenticated: true,
            sidebarWidthGroup: 'wc-kpis',
        },
    },
];
